// Rasterize an on-screen SVG (e.g. a recharts chart) to a PNG data URL using
// only browser APIs: serialize → load into <img> → draw on <canvas> → toDataURL.
export async function captureSvgAsPng(svg: SVGSVGElement, scale = 2): Promise<string> {
  const rect = svg.getBoundingClientRect();
  const width = Math.round(rect.width || Number(svg.getAttribute('width')) || 600);
  const height = Math.round(rect.height || Number(svg.getAttribute('height')) || 300);

  const clone = svg.cloneNode(true) as SVGSVGElement;
  clone.setAttribute('width', String(width));
  clone.setAttribute('height', String(height));
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  const xml = new XMLSerializer().serializeToString(clone);
  const src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(xml)}`;

  const img = new Image();
  img.width = width;
  img.height = height;
  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('Failed to load SVG for capture'));
    img.src = src;
  });

  const canvas = document.createElement('canvas');
  canvas.width = width * scale;
  canvas.height = height * scale;
  const cctx = canvas.getContext('2d');
  if (!cctx) throw new Error('Canvas 2D context unavailable');
  cctx.fillStyle = '#ffffff';
  cctx.fillRect(0, 0, canvas.width, canvas.height);
  cctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL('image/png');
}
